var _defs, _path, _line, _line2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtmUseActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_118414",
    "data-name": "Group 118414",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 50,
    viewBox: "0 0 60 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28267",
    "data-name": "Rectangle 28267",
    width: 60,
    height: 50,
    fill: "none",
    stroke: "#141740",
    strokeWidth: 2
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_110821",
    "data-name": "Path 110821",
    d: "M32.25,22.5,11,10,21,5,42.25,17.5v20l-10,5Z",
    transform: "translate(2.75 1.25)",
    fill: "none",
    stroke: "#141740",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_6842",
    "data-name": "Line 6842",
    y2: 2.5,
    transform: "translate(21.25 18.75)",
    fill: "none",
    stroke: "#141740",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_6843",
    "data-name": "Line 6843",
    y2: 2.5,
    transform: "translate(38.75 8.75)",
    fill: "none",
    stroke: "#141740",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_117579",
    "data-name": "Group 117579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117578",
    "data-name": "Group 117578",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110822",
    "data-name": "Path 110822",
    d: "M20.837,7.352,33.541,1l20,10L39.216,18.162",
    transform: "translate(5.209 0.25)",
    fill: "none",
    stroke: "#141740",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110823",
    "data-name": "Path 110823",
    d: "M34.176,20.892,21,27.479l-20-10,14.8-7.4",
    transform: "translate(0.25 2.52)",
    fill: "none",
    stroke: "#141740",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110824",
    "data-name": "Path 110824",
    d: "M22.5,20.9l-2.683,1.4a1.249,1.249,0,0,0-1.185-.016L10,17.49a1.249,1.249,0,0,0,.029-2.2L12.5,14",
    transform: "translate(2.5 3.5)",
    fill: "none",
    stroke: "#141740",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110825",
    "data-name": "Path 110825",
    d: "M28,5.894,31.153,4.25a1.256,1.256,0,0,0,1.185.015L40.97,9.06a1.249,1.249,0,0,0-.029,2.2L38,12.8",
    transform: "translate(7 1.063)",
    fill: "none",
    stroke: "#141740",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110826",
    "data-name": "Path 110826",
    d: "M34.75,34.125,21,41,1,31",
    transform: "translate(0.25 7.75)",
    fill: "none",
    stroke: "#141740",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6844",
    "data-name": "Line 6844",
    x1: 13.75,
    y2: 6.875,
    transform: "translate(45 30)",
    fill: "none",
    stroke: "#141740",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110827",
    "data-name": "Path 110827",
    d: "M34.75,24.125,21,31,1,21",
    transform: "translate(0.25 5.25)",
    fill: "none",
    stroke: "#141740",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6845",
    "data-name": "Line 6845",
    x1: 13.75,
    y2: 6.875,
    transform: "translate(45 17.5)",
    fill: "none",
    stroke: "#141740",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110828",
    "data-name": "Path 110828",
    d: "M34.75,29.125,21,36,1,26",
    transform: "translate(0.25 6.5)",
    fill: "none",
    stroke: "#141740",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6846",
    "data-name": "Line 6846",
    x1: 13.75,
    y2: 6.875,
    transform: "translate(45 23.75)",
    fill: "none",
    stroke: "#141740",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmUseActive);
export default __webpack_public_path__ + "static/media/atmUseActive.aedc988ac2e6484c20b80a00618c3805.svg";
export { ForwardRef as ReactComponent };